import { AppState } from '@appStates';
import { createSelector } from '@ngrx/store';
import { IProductState } from '../state/info-drug.state';
import { IProduct } from '../../shared/interfaces/product.model'
import { BzProduct } from '@interfaces';


const selectProductState = (state: AppState): IProductState => state.infoForDrug;

export const selectProductInfos = createSelector(
    selectProductState,
    (state: IProductState): IProduct => state.product
);

export const selectFullInstraction = createSelector(
    selectProductState,
    (state: IProductState): string => state.fullInstraction
);

export const selectSimilarProducts = createSelector(
  selectProductState,
  (state: IProductState): BzProduct[] => state.similar
);

export const selectAnalogs = createSelector(
    selectProductState,
    (state: IProductState): BzProduct[] => state.analogs
);

export const selectLoadingState = createSelector(
    selectProductState,
    (state: IProductState): boolean => state.loading
);
